/**
 * @file Form responsible for requesting password reset link.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { cleanApolloError } from '../../util/normalize-errors';
import InputGroup from '../global/InputGroup';
import Button from '../global/Button';
import Alert from '../global/Alert';
import { getAsset } from '../../util/assets';

class PasswordResetRequestForm extends Component {
  static propTypes = {
    resetPasswordRequest: PropTypes.func.isRequired,
  };

  state = {
    loading: false,
    error: '',
    emailSent: false,
  };

  onFormSubmit = async event => {
    event.preventDefault();
    this.setState(() => ({ error: '', loading: true }));

    const email = this.emailInput.value;

    try {
      await this.props.resetPasswordRequest(email);

      this.setState(() => ({
        error: '',
        loading: false,
        emailSent: true,
      }));
    } catch ({ message }) {
      this.setState(() => ({
        error: cleanApolloError(message),
        loading: false,
      }));
    }
  };

  render() {
    const { error, emailSent } = this.state;

    return (
      <form className="form-password-reset" onSubmit={this.onFormSubmit}>
        <div className="mb-4">
          Enter the email associated with your account, and we&apos;ll send you
          a password reset link.
        </div>
        {!emailSent && (
          <div>
            <InputGroup
              id="email"
              type="email"
              name="email"
              label="Your Email"
              labelSrOnly
              required
              addon={
                <img alt="" src={getAsset('/shutterbug/icons/email.svg')} />
              }
              placeholder="Your email address..."
              inputRef={ref => {
                this.emailInput = ref;
              }}
              wrapperClassName="mb-2"
            />

            <Button
              type="submit"
              className="btn-block mt-4"
              disabled={this.state.loading}
            >
              Reset my password
            </Button>
          </div>
        )}

        {error && (
          <Alert type="danger" className="mt-2">
            {error}
          </Alert>
        )}

        {emailSent && (
          <Alert type="success" className="mt-2">
            Awesome, we’ve sent a reset link at {this.emailInput.value}. Please
            check your mailbox.
          </Alert>
        )}
      </form>
    );
  }
}

export default PasswordResetRequestForm;
